/*
  Cart drawer upsell - "Goes well with"

  Lives in its own asset, loaded from layout/theme.liquid, for one specific
  reason: the markup it drives sits inside #CartDrawer, and CartDrawer's
  renderContents() refreshes that region with innerHTML. Scripts injected via
  innerHTML never execute, so an inline <script> in the snippet is dead on every
  re-render - including the very first add, when the cart starts empty and the
  snippet's cart.item_count > 0 guard means the script was never on the page at
  all. Binding once here, delegated on document, survives every redraw.
*/
(function () {
  if (window.__gpUpsellBound) return;
  window.__gpUpsellBound = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-gp-upsell-add]');
    if (!btn || btn.hasAttribute('disabled')) return;
    e.preventDefault();

    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    var drawer = document.querySelector('cart-drawer');
    var original = btn.textContent;
    btn.setAttribute('disabled', 'disabled');
    btn.textContent = 'Adding...';

    var body = {
      items: [{ id: Number(id), quantity: 1, properties: { _added_from: 'cart_upsell' } }]
    };

    // Ask for the drawer sections back so it re-renders in place, the same way
    // the theme's own product form does.
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state && state.status) throw new Error(state.description || 'add failed');
        if (drawer && state.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        btn.removeAttribute('disabled');
        btn.textContent = original;
      });
  });

  // 3+1 meter (snippets/gp-three-plus-one.liquid): "Add N more" tops the line up to 4
  // through the drawer's own quantity update, so stock errors and the redraw behave
  // exactly like the + button.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-gp-31-add]');
    if (!btn || btn.hasAttribute('disabled')) return;
    var items = btn.closest('cart-drawer-items');
    if (!items || typeof items.updateQuantity !== 'function') return;
    e.preventDefault();
    btn.setAttribute('disabled', 'disabled');
    items.updateQuantity(btn.getAttribute('data-index'), Number(btn.getAttribute('data-quantity')));
  });
})();
